module.exports = __webpack_public_path__ + "img/main_subbanner.ce02d65b.png";